import { Button, Typography } from '@mui/material';
import BaseModal from '../BaseModal';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

function ConfirmModal({
  show,
  onHide,
  confirmTitle,
  confirmMessage,
  confirm,
  showCancelButton = false,
}) {
  const { t } = useTranslation();

  return (
    <BaseModal
      arial-labelledby="confirm-modal-title"
      open={show}
      onClose={onHide}
      title={confirmTitle}
      onSubmit={confirm}
      submitButtonText={t(StringKeys.CONFIRM)}
      size="sm"
      enableEnterKey={true}
      footerContent={
        showCancelButton ? (
          <>
            <Button onClick={onHide} sx={{ mr: 2 }}>
              {t(StringKeys.CANCEL)}
            </Button>
            <Button variant="contained" onClick={confirm} color="secondary">
              {t(StringKeys.CONFIRM)}
            </Button>
          </>
        ) : undefined
      }
    >
      <Typography whiteSpace="pre-line">{confirmMessage}</Typography>
    </BaseModal>
  );
}

export default ConfirmModal;
